import {useEffect, useMemo, useState} from 'react';
import {IFormFieldDesignContext} from '@src/@interfaces/contexts/IFormFieldDesignContext';
import {defaultValue, FormFieldDesign} from '@src/contexts/FormFieldDesignContext';
import {isEqual} from '@src/helpers/is-equal';

export default function useFormFieldDesignContextProviderValue(props?: {
    initialValue?: Partial<IFormFieldDesignContext>,
    contextValue?: Partial<IFormFieldDesignContext>,
}) {
    const [value, setValue] = useState<IFormFieldDesignContext>({
        ...defaultValue,
        ...props?.initialValue,
        ...props?.contextValue,
    });

    useEffect(() => {
        const newValue = {...value, ...props?.contextValue};
        if (!isEqual(value, newValue)) {
            setValue(newValue);
        }
    }, [props, value]);

    return useMemo<FormFieldDesign>(() => [value, setValue], [value]);
}
